module.exports = __webpack_public_path__ + "img/Ssa5.33246e63.png";